
import { defineComponent, watch, reactive, ref } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
//services
import personService from "@/core/services/PersonService";
import GlobalService from '@/core/services/GlobalService';
import accountService from "@/core/services/AccountService"
//libraries
import { errManager, showNotification } from "@/core/config/Tools";
//components
import AddEditFunction from '@/views/functions/modals/AddEdit.vue'
import AddEditPerson from '@/views/persons/modals/AddEdit.vue'
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "clubs-modal-user",
    props: {
        idinstitution: {
            type: null,
            required: true,
            default: () => ({})
        },
        itemUser: {
            type: null,
            required: false,
            default: () => ({})
        },
        listStatus: {
            type: null,
            required: true,
            default: () => <any>([])
        }
    },
    components: {
        AddEditFunction, AddEditPerson
    },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const { t } = useI18n();
        const loading = ref(false)
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const AddEditFunctionRef = ref<any>(null);
        const AddEditPersonRef = ref<any>(null)

        const form = reactive<any>({});
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});
        const listPeople = ref<any[]>([]);
        const listFunctions = ref<any[]>([]);
        const listProfiles = ref<any[]>([]);

        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = async() => {
            titleDialog.value = (props.itemUser) ? 'Editar cuenta de usuario' : 'Registrar cuenta de usuario'
            //getListFunctions()
            await getAllData();
            if(props.itemUser) Object.assign(form, props.itemUser);
        };

        const onClosed = () => {
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const remoteMethod = async (query: string) => {
            if (query.trim()) {
                loading.value = true
                await personService.postOptions('search', {search: query.toLowerCase()})
                .then((res)=>{
                    listPeople.value = res.data
                    loading.value = false
                }).catch(({response})=>{
                    loading.value = false
                    errManager(response)
                })
            } else {
                listPeople.value = []
            }
        };

        const getListProfiles = async () => {
            const res = await GlobalService.get('api', 'profile');
            listProfiles.value = res.data;
        }

        const getListFunctions = async () => {
            const res = await GlobalService.get('api', 'functions?modality=select');
            listFunctions.value = res.data
        };

        const getAllData = async () => {
            try {
                loading.value = true;
                const [states, profiles] = await Promise.all([
                    getListProfiles(),
                    getListFunctions()
                ])
            } catch (error) {
                errManager(error)
            } finally {
                loading.value = false;
            }
        }

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid) => {
                if (valid)
                    return (props.itemUser) ? update() : save()

            });
        };

        const save = async () => {
            loading.value = true
            form.idinstitution = props.idinstitution
            await accountService.postOptions('save', form)
                .then((res) => {
                    loading.value = false
                    showNotification(res.data)
                    if(res.data.status == 'success') {
                        isModalVisible.value = false
                        emit("onResponse", res.data)
                    }
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        };

        const update = async() => {
            loading.value = true
            await accountService.update(form.idaccount, 'update', form)
            .then((res)=>{
                loading.value = false
                showNotification(res.data)
                if(res.data.status == 'success') {
                    isModalVisible.value = false
                    emit("onResponse", res.data)
                }
            }).catch(({response})=>{
                loading.value = false
                errManager(response)
            })
        }

        const openAddFunction = () => {
            if(AddEditFunctionRef.value){
                AddEditFunctionRef.value.openModal();
            }
        };

        const openAddPerson = () => {
            if(AddEditPersonRef.value){
                AddEditPersonRef.value.openModal();
            }
        }

        const onResponseFunction = (data: any) => {
            if (!data) return;
            if(data.status == 'success') getListFunctions()
        };

        const generateUsername = () => {
            if (!form?.idperson.people.trim()) return;

            const words = form?.idperson.people.trim().toLowerCase().split(" "); 
            if (words.length < 2) return; // Aseguramos que haya al menos nombre y un apellido

            const firstLetter = words[0][0]; // Primera letra del primer nombre
            const lastName = words[words.length - 1]; // Último apellido
            const randomNumber = Math.floor(100 + Math.random() * 900); // Número aleatorio de 3 dígitos
            form.username = `${firstLetter}${lastName}${randomNumber}`; // Generar usuario
        }

        const generatePassword = () => {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+";
            form.password = Array.from({ length: 8 }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join("");
        }

        watch(() => props.itemUser, // Observa cambios en itemUser
            (newValue) => {
                if (newValue) {
                form.password = newValue.coincidence;
                }
            },
            { immediate: true } // Se ejecuta de inmediato si itemUser ya tiene datos
        )

        return {
            t,
            loading,
            titleDialog,
            isModalVisible,
            AddEditFunctionRef,
            AddEditPersonRef,
            form,
            rules,
            ruleFormRef,
            listPeople,
            listFunctions,
            listProfiles,
            //events
            onOpen,
            onClosed,
            openModal,
            remoteMethod,
            getListFunctions,
            submitForm,
            openAddFunction,
            openAddPerson,
            onResponseFunction,
            generateUsername,
            generatePassword

        }

    },
})
